import { createGlobalStyle } from "styled-components";
import "react-toastify/dist/ReactToastify.css";

export const GlobalStyle = createGlobalStyle`
    * {
        margin: 0 auto;
        padding: 0;
        box-sizing: border-box;
        font-family: 'BasisGrotesquePro', sans-serif;
    }

    body {
        background-color: #F6F6F6;
    }

    h1, h2, h3, h4, h5, h6, strong {
        font-weight: 700;
    }

    button {
        cursor: pointer;
        background: #EC1978;
        color: #fff;
        font-size: 18px;
        font-style: normal;
        /* font-weight: 700; */
        line-height: normal;
        letter-spacing: 0.9px;
        border-radius: 145px;
        border: 0;

        &:hover {
            filter: brightness(0.9);
        }

        &:disabled {
            background-color: #AFB1B3;
        }
    }

    .secondary-button {
        background-color: #2AAEAE;
    }

    input {
        width: 100%;
        padding: 0 1.25rem;
        height: 48px;
        border-radius: 25px;

        background-color: transparent;

        font-weight: 400;
        font-size: 1rem;

        border-color: #8C8C8C;
        outline: 0;

        &:focus {
            background: #e7e9ee;
            border-color: #495156;
        }

        &:disabled {
            background-color: #E5E5E5;
        }
    }

    [disabled] {
        opacity: 0.6;
        cursor: not-allowed;
    }


    .react-modal-overlay {
        background: rgba(0,0,0,0.5);

        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;

        display: flex;
        align-items: center;
        justify-content: center;

        overflow-y: auto;

    }
    .react-modal-content{
        width: 100%;
        max-width: 750px;
        
        margin-top: 10rem;
        margin-bottom: 20px;

        background: #fff;
        padding: 3rem;
        position: relative;
        border-radius: 0.24rem;
    }

    .react-modal-close {
        position: absolute;
        right: 1.5rem;
        top: 1.5rem;
        border: 0;
        background: transparent;

        transition: filter 0.2s;

        &:hover{
            filter: brightness(0.9);
        }
    }

    .control {
        width: 100%;

        label {
            font-weight: 700;
            color: #495156;
            font-size: 1rem;
            line-height: 16px;
            margin-bottom: 8px;
        }

        select {
            width: 100%;
            height: 50px;
            background-color: transparent;
            background: transparent ;
            border-radius: 145px;
            border: 1.23px solid #8C8C8C;
            outline: 0;
            padding: 0 1rem;
            appearance: none;
            position: relative;

            -webkit-appearance: none;
            -moz-appearance: none;
            background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUCAMAAACtdX32AAAAdVBMVEUAAAD///8AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAhMdQaAAAAJ3RSTlMAAAECAwQGBwsOFBwkJTg5RUZ4eYCHkJefpaytrsXGy8zW3+Do8vNn0bsyAAAAYElEQVR42tXROwJDQAAA0Ymw1p9kiT+L5P5HVEi3qJn2lcPjtIuzUIJ/rhIGy762N3XaThqMN1ZPALsZPEzG1x8LrFL77DHBnEMxBewz0fJ6LyFHTPL7xhwzWYrJ9z22AqmQBV757MHfAAAAAElFTkSuQmCC);
            background-position: 100%;
            background-repeat: no-repeat;

            &:hover {
                border: 1.23px solid #495156;
            }

            &:focus {
                border: 1.23px solid #F20A76;
                background-color: transparent;
            }
        }
    }

    .radioBoxes {
        display: flex;
        margin-top: 20px;

        div:first-child {
            margin-right: 50px;
        }
    }

    .radio-container {
        display: flex;
        align-items: center;
        justify-content: center;

        label {
            font-weight: 700;
            color: #495156;
            font-size: 1rem;
            line-height: 16px;
        }
    }

    input[type="radio"] {
        width: 16px;
        height: 16px;
        margin-right: 15px;
        accent-color: #EC1978;
    }
    input[type="checkbox"] {
        accent-color: #EC1978;
        width:16px;
    }
    
    input:-webkit-autofill,
    input:-webkit-autofill:hover, 
    input:-webkit-autofill:focus, 
    input:-webkit-autofill:active{
        -webkit-box-shadow: 0 0 0 30px white inset !important;
    }

    input {
        width: 100%;
        padding: 0 1.25rem;
        height: 48px;
        border-radius: 25px;

        border: 1.23px solid #8C8C8C;
        font-weight: 400;
        font-size: 1rem;

        outline: 0;

        &:hover {
            border: 1.23px solid #495156;
        }

        &:focus {
            border: 1.23px solid #F20A76;
            background-color: transparent;
        }

        &:active {
            background-color: transparent;
        }
    }

    .modal-content {
        border-radius: 24px !important;
        width: 620px;
    }

    .modalNovo .modal-content {
        height: 355px;
        width: 620px;
        border: 0;
        max-width: 620px;
    }

    .modalAdesao .modal-content {
        width: 620px;
        border: 0;
        max-width: 620px;
    }

    .modal-header .close {
        padding: 0;
        margin: 0;
        font-size: 30px;
        width: 30px;
        height: 30px;
        font-weight: 100;
    }

    .input-error-message {
        color: #E81B1B;
        font-weight: 300px;
        line-height: 16px;
        font-size: 1rem;
        display: block;
        margin: 0;
        margin-top: 8px;
    }

    .checkboxLabel {
        margin-top:9px;
        margin-left:12px;
    }

    .required-indicator {
        display: inline-block;
        margin: 0 0 0 0.25rem;
        color: #EC1978;
        font-weight: 700;
    }

`;
